import React from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { arrowDownIcon } from '../../constants/icons';

const SelectedDropdown = ({ id, title, icon, selectedOption, options, onSelect, placeholder }) => (
    <DropdownButton
        id={id}
        title={<div className="selected-dropdown-text"><strong>{title}</strong> {selectedOption || placeholder} <span className="arrow-icon">{arrowDownIcon}</span></div>}
        onSelect={onSelect}
        variant="light"
        className="selected-dropdown"
        align="end"
        flip={false}
    >
        {options.map((option, index) => (
            <Dropdown.Item
                key={index}
                eventKey={option}
                active={selectedOption === option}
            >
                <span className="option-text">{option} </span> <span className="check-icon">{icon} </span>
            </Dropdown.Item>
        ))}
    </DropdownButton>
);

export default SelectedDropdown;
